












import { Component, Vue } from "vue-property-decorator";
import request from "@/api/index";
import { ILiveItem } from "@/api/types";
import Base from "@/template/public/Base.vue";
import { setImgSrc } from "@/common/Utils";
@Component
export default class NewsReleaseDetails extends Base {
  private id: string = "";
  private newsInfo: object = {};
  public request = new request();
  created() {
    this.id = this.$route.query.id as string;
    this.newsDetails();
  }

  newsDetails() {
    this.request.detail(this.id).then(result => {
      if (result.code == 0) {
        this.newsInfo = result.data;
        this.$nextTick(() => {
          setImgSrc(this.$refs.newsContent as Element);
        });
        // 分享信息获取
        // this.getShareInfo(this.newsInfo.appId);
      }
    });
  }
}
